import React from 'react'
import ChangelogInstance from '../ChangelogInstance';

const OneDotEightDotOne = () => {
  return (
    <ChangelogInstance version="1.8.1" date="2019-02-25">
      <li>Some minor fixes discovered after 1.8.0 release</li>
    </ChangelogInstance>
  );
}

export default OneDotEightDotOne;